export default {
  groupData: [],
  searchText: '',
  sortName: 'group_name',
  sortAsc: true
}
